<script setup>
defineProps({
  item: {
    type: Object,
  },
})

const appSettings = useAppSettingsStore()

const { openChat } = useTalkdeskChat()

function handleChatClick() {
  openChat()
}
</script>

<template>
  <div class="icon-set">
    <NuxtImg
      v-if="item?.aprimoIcon?.url"
      provider="fastlyAprimo"
      :src="item.aprimoIcon.url"
      class="icon-set__icon max-w-[44px] max-h-[44px]"
      :alt="item.iconAltText?.value ?? ''"
      :width="item.aprimoIcon?.width ?? 44"
      :height="item.aprimoIcon?.height ?? 44"
      loading="lazy"
    />
    <div
      v-if="item?.contactItems?.expandedValue?.length"
      class="prose"
    >
      <p
        v-for="contact in item.contactItems.expandedValue"
        :key="contact.contactLabel.value"
        class="m-0!"
      >
        <template v-if="!contact?.contactLink?.value">
          <span
            v-if="contact?.contactLabel?.value"
            class="font-medium"
          >
            {{ contact.contactLabel.value }}:
          </span>
          <span v-if="contact?.contactText?.value">
            {{ contact.contactText.value }}
          </span>
        </template>
        <template v-else-if="appSettings?.talkdeskSettings?.enableChat">
          {{ contact?.contactLabel?.value || '' }}
          <button
            type="button"
            class="underline cursor-pointer"
            @click="handleChatClick"
          >
            {{ contact.contactLink.value.text }}
          </button>
        </template>
        <template v-else>
          <ULink
            v-if="contact?.contactLink?.value?.href"
            :to="useCmsUrl(contact.contactLink.value.href)"
            :locale="false"
          >
            {{ contact.contactLink.value.text }}
          </ULink>
        </template>
      </p>
    </div>
  </div>
</template>

<style lang="scss">
.icon-set {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;

  p {
    line-height: 1.875;
    text-wrap: pretty;
  }

  a {
    color: var(--color-med-dark-gray);
  }

  > * {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.icon-set__icon {
  display: block;
}

.icon-set__body {
  color: var(--color-med-navy);

  > * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
